import { packagesService } from '@/services';

export const packageModule = {
  namespaced: true,
  state: () => ({
    list:{
      data: null,
      error: null,
    },
    deletePackage:{
      data: null,
      status: null,
    },
    newPackage:{
      data: null,
      status: null,
    },
  }),
  mutations: {
    load(state,request) {
      packagesService.getPackages(request.pagination,request.filters)
        .then((res) => {
          state.list.data = res
        })
        .catch((error) => {
          state.list.data = null
          state.list.error = error
        });      
    },
    deletePackage(state, id) {
      packagesService.deletePackage(id)
        .then((res) => {
          state.deletePackage.data = res;
          state.deletePackage.status = {
            deleted: true
          }
        })
        .catch((error) => {
          state.deletePackage.data = null
          state.deletePackage.status = {
            error
          };
        });      
    },
    sendnewPackage(state, body){
      packagesService.newPackage(body)
      .then((res) => {
        state.newPackage.data = res;
        state.newPackage.status = {
          created: true,
        };
      })
      .catch((error) => {
        state.newPackage.data = null
        state.newPackage.status = {
          error,
        };
      }); 
    },
  }
}